// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"a86738b9","453":"b56fc5ca","465":"57d695d7"}[chunkId] + ".chunk.js";
};